import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/logo.png";
import { AuthContext } from "../../../../context/AuthProvider";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);
  const handleLogout = () => {
    logOut()
      .then(() => {})
      .catch((err) => console.error(err));
  };
  const menuItems = (
    <React.Fragment>
      <li className="text-primary hover:text-indigo-500">
        <Link to="/">Home</Link>
      </li>
      <li className="text-primary hover:text-indigo-500">
        <Link to="/about">About</Link>
      </li>
      <li className="text-primary hover:text-indigo-500">
        <Link to="/blog">Blog</Link>
      </li>
      {user?.uid ? (
        <>
          <li className="text-primary hover:text-indigo-500">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="text-blue-500 hover:text-indigo-500">
            <Link to="/login">
              <button onClick={handleLogout}>Logout</button>
            </Link>
          </li>
        </>
      ) : (
        <li className="text-primary hover:text-indigo-500">
          <Link to="/login">Login</Link>
        </li>
      )}
    </React.Fragment>
  );

  return (
    <div className="navbar flex justify-between text-gray-500">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={1}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {menuItems}
          </ul>
        </div>
        <Link
          to="/"
          className="btn btn-ghost normal-case font-bold text-3xl text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary"
        >
          <img src={logo} alt="phone-hub" className="h-12 mr-3" /> PHONE HUB
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0">{menuItems}</ul>
      </div>
      <label
        htmlFor="dashboard-drawer"
        tabIndex={2}
        className="btn btn-ghost lg:hidden"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h8m-8 6h16"
          />
        </svg>
      </label>
    </div>
  );
};

export default Header;
